import {Typography} from 'components/Typography';
import classNames from 'classnames';
import {FC} from 'react';
import style from './style.module.scss';
import {IResultCharacteristicDataList} from 'modules/product-card/helpers/characteristics';

interface IProductCharacteristicsValueProps {
    children: string;
}

const ProductCharacteristicsValue: FC<IProductCharacteristicsValueProps> = ({children}) => {
    return (
        <Typography variant={'label-14-r'}>
            {children}
            <span className={style.valueComma}>, </span>
        </Typography>
    );
};

interface IProps {
    dataList: IResultCharacteristicDataList[];
    title: string;
}

export const DetailedCharacteristicsListContent: FC<IProps> = ({dataList, title}) => {
    return (
        <div className={style.main}>
            <Typography className={style.title} variant={'title-18-m'}>
                {title}
            </Typography>
            <div className={style.valueContainer}>
                {dataList.map(({link, text}) => {
                    if (link) {
                        return (
                            <a className={style.value} href={link} key={text}>
                                <ProductCharacteristicsValue>{text}</ProductCharacteristicsValue>
                            </a>
                        );
                    }

                    return (
                        <span className={classNames(style.value, style.noLink)} key={text}>
                            <ProductCharacteristicsValue>{text}</ProductCharacteristicsValue>
                        </span>
                    );
                })}
            </div>
        </div>
    );
};
